import React from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import PanelHeader from '@prisjakt/ui-panel-header';
import { withRouter } from 'react-router';

import ThemeListItem from './list-item';
import CampaignBreadcrumb from '../breadcrumb';

import './index.scss';
import '../campaign-header/index.scss';

const styles = bemGenerator('themes', ['theme']);
const headerStyles = bemGenerator('campaign-header', [
  'container',
  'logo',
  'content',
  'title',
  'description',
]);

const validCampaignTypes = ['OFFER', 'GIFTGUIDE'];

class Themes extends React.PureComponent {
  getCampaigns(ongoing) {
    return this.props.data.campaigns.filter(campaign =>
      ongoing
        ? campaign.state === 'ACTIVE' &&
          validCampaignTypes.indexOf(campaign.type) >= 0
        : campaign.state === 'UPCOMING' &&
          validCampaignTypes.indexOf(campaign.type) >= 0
    );
  }

  render() {
    const ongoingCampaigns = this.getCampaigns(true);
    const upcomingCampaigns = this.getCampaigns();
    const imageHeaderSource = `${this.context.market.cdn}/g/campaigns/themes/campaigns-logo.png`;

    return (
      <div className={styles.theme}>
        <CampaignBreadcrumb />
        <div className={`${headerStyles.block} row`}>
          <div className={headerStyles.container}>
            <div className={headerStyles.logo}>
              <img
                src={imageHeaderSource}
                alt={this.context.t('campaigns', 'themes.title')}
              />
            </div>
            <div className={headerStyles.content}>
              <h1 className={headerStyles.title}>
                {this.context.t('campaigns', 'themes.title')}
              </h1>
              <p className={headerStyles.description}>
                {this.context.t('campaigns', 'themes.description')}
              </p>
            </div>
          </div>
        </div>
        {ongoingCampaigns.length !== 0 && (
          <section>
            <div className="row">
              <div className="column">
                <PanelHeader
                  title={this.context.t(
                    'campaigns',
                    'themes.ongoing-campaigns'
                  )}
                />
              </div>
            </div>
            <ul>
              {ongoingCampaigns.map(campaign => (
                <ThemeListItem key={campaign.name} campaign={campaign} />
              ))}
            </ul>
          </section>
        )}
        {upcomingCampaigns.length !== 0 && (
          <section>
            <div className="row">
              <div className="column">
                <PanelHeader
                  title={this.context.t(
                    'campaigns',
                    'themes.upcoming-campaigns'
                  )}
                />
              </div>
            </div>
            <ul>
              {upcomingCampaigns
                .filter(campaign => campaign.type === 'OFFER')
                .map(campaign => (
                  <ThemeListItem key={campaign.name} campaign={campaign} />
                ))}
            </ul>
          </section>
        )}
      </div>
    );
  }
}

Themes.propTypes = {
  data: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

Themes.defaultProps = {};

Themes.contextType = AppContext;

export default withRouter(Themes);
